 <template>
    <div class="graph_block">
        <div class="graph_title">
            <h4>LCA</h4>
            
              
   <vs-dropdown vs-custom-content vs-trigger-click>
                <vs-button color="primary" class="filter-btn" type="border">
                    <img src="@/assets/images/main/icon-filter.svg"> 
                </vs-button>

                         <vs-dropdown-menu ref="filter_menu" class="filters-content dashboard-filters">

                    <div class="filters-form-fileds">
                        <div class="form-container">
                           <div class="vx-row">  
                             <div class="vx-col w-full con-select">
                                                 <label class="typo__label">Date Range</label>

                     <DatePickerCustom  :typeable="true" v-model="selected_createdDateRange"   @ondateSelection="reloaStats" />

                  </div>
             <div class="vx-col w-full con-select">
                    <label class="typo__label">Case Type</label>

                     
                   <multiselect
                      @input="changedVisaType"
                      v-model="selectedCaseTypes"
                      :options="allCaseTypes"
                      :multiple="false"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Case Type"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    >
                     
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Case Type(s) Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>

               
                  <div class="vx-col w-full con-select">
                    <label class="typo__label">Case Subtype</label>
               <multiselect
                     
                      v-model="selectedCaseSubTypes"
                      :options="allCaseSubTypes"
                      :multiple="true" :hideSelected="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Case Subtype"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    >
                      
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Case Subtype(s) Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>
                  
        </div>
                        </div>
                    </div>
                    <div class="filters-status">
                        <div class="left-buttons">
                            <!-- <vs-button color="success" class="clearall" type="filled">Clear All <i class="material-icons">
                      refresh
                      </i>
                </vs-button>-->
                        </div>
                        <div class="right-buttons">
                            <vs-button color="success" class="save" type="filled" v-on:click="getStats()">Apply</vs-button>
                            <vs-button color="dark" class="cancel" type="filled" v-on:click="clear_filter($event)">Clear</vs-button>
                        </div>
                    </div>
                </vs-dropdown-menu>
       </vs-dropdown>
               
            
        </div>
   
        <div class="graph_cnt" >
        
       
            <template>
              <!--<apexchart width="320" type="donut" :options="options" :series="series" ></apexchart> -->
              <div v-show="!loading && wallsLoaded && statusCount>0" id="lca-chart" style="height:250px;"></div>
            </template>
             
            
            <ul class="chart_legends" v-if="!loading && statusCount>0">
              <template v-for="(cData,ind) in chartData"  >
                      <li :class="replaceSpaces(cData.category)" :key="ind"><p><span></span>{{cData.category}}</p></li>         
              </template>
             
            </ul>
            <template v-if="!loading && statusCount<=0">
              <div class="no_data">No Data Available</div>
            </template>
             <chartLoading v-if="loading || !wallsLoaded" />

        </div>
    </div>
</template>

            
<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import VueApexCharts from 'vue-apexcharts'
import Vue from 'vue'

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import moment from 'moment'
import chartLoading from "@/views/wall/chartLoading.vue"
am4core.useTheme(am4themes_animated);
import DatePickerCustom from "@/views/common/_date_picker_custom.vue";
import { _ } from 'core-js'
Vue.use(VueApexCharts)


Vue.component('apexchart', VueApexCharts)

export default {
    components: {
        DateRangePicker,
        chartLoading,
        DatePickerCustom
       
    },
    data: function () {
         
       


        return {
          loading:true,
           isOpenDateFilter:false,
         filterText:"",
          chartData:[],
            selected_createdDateRange: ["", ""],
            autoApply: "",
            options: {
              labels: [],
              legend:{
                position: 'top',
              },

          },
           series: [],
           statusCount:0,
        //   allCaseTypes:[],
           selectedCaseTypes:null,

           allCaseSubTypes:[],
           selectedCaseSubTypes:[]
           

        }
    },
   
    mounted() {

     
      this.getStats();
     

    },
    methods: {
      reloaStats(seleteddates) {

         this.selected_createdDateRange["startDate"] = seleteddates.startDate
        this.selected_createdDateRange["endDate"] =  seleteddates.endDate;
        this.getStats();
    },
         clear_filter(){
        this.selectedCaseTypes =[];
        this.selectedCaseSubTypes =[];
        this.selected_createdDateRange =[];
        this.filterText ='';
        this.$refs["filter_menu"].dropdownVisible = false;
        this.getStats();

      } , 
      togleDateFIlter(){
            
            
            this.isOpenDateFilter =  !this.isOpenDateFilter;
            // if(this.isOpenDateFilter){
            //     document.addEventListener("click", ()=>{
            //         this.isOpenDateFilter =false;
                
            //     });
            // }
            

        },
       generateDate(type='Today'){
            let startDate = moment().startOf('day').format('YYYY-MM-DD');
             let endDate = moment().endOf('day').format('YYYY-MM-DD');
             this.filterText = "Today";
             if(type=='Today'){
                    startDate = moment().startOf('day').format('YYYY-MM-DD');
                     endDate = moment().endOf('day').format('YYYY-MM-DD');
                       this.selected_createdDateRange["startDate"] = startDate;
                      this.selected_createdDateRange["endDate"] = endDate;

             }else if(type=='This Week'){
                  this.filterText = "This Week";
                    startDate = moment().startOf('week').format('YYYY-MM-DD');
                    endDate = moment().endOf('week').format('YYYY-MM-DD');
                     this.selected_createdDateRange["startDate"] = startDate;
                    this.selected_createdDateRange["endDate"] = endDate;

             }else if(type=='This Month'){
                    this.filterText = "This Month";
                    startDate = moment().startOf('month').format('YYYY-MM-DD');
                    endDate = moment().endOf('month').format('YYYY-MM-DD');
                     this.selected_createdDateRange["startDate"] = startDate;
                    this.selected_createdDateRange["endDate"] = endDate;
                    

             }else if(type == 'Custom_date'){
                 
                startDate =this.selected_createdDateRange['startDate'];
                endDate=this.selected_createdDateRange['endDate'];
                 startDate =   moment(startDate).format('YYYY-MM-DD')
                 endDate =  moment(endDate).format('YYYY-MM-DD')
               
                 this.filterText =startDate+" To "+endDate;
                 
               
             }

             this.isOpenDateFilter =false;
           
           //  this.getStats();
             
            
            
        },
      initChart(){

     
var chart = am4core.create("lca-chart", am4charts.PieChart3D);
chart.logo.disabled = true;
// Add data
chart.data = this.chartData;
/*[{
  "category": "white",
  "count": 501.9,
  "color": "red"
}, {
  "category": "red",
  "count": 301.9,
  "color": "yellow"
}, {
  "category": "orange",
  "count": 201.1,
  "color": "orange"
}, {
  "category": "green",
  "count": 165.8,
  "color": "green"
}, {
  "category": "blue",
  "count": 139.9,
  "color": "blue"
}];
*/
//chart.contentHeight =320;
//chart.contentWidth =500;

//chart.width=200;
chart.height=250;
// Add and configure Series
var pieSeries = chart.series.push(new am4charts.PieSeries3D());
pieSeries.dataFields.value = "count";
pieSeries.dataFields.category = "category";
pieSeries.innerRadius = am4core.percent(60);
pieSeries.ticks.template.disabled = true;
pieSeries.labels.template.disabled = true;

// This is not working and produces an error
// pieSeries.slices.template.adapter.add("fill", function (fill, target) {
//     return target.dataItem.dataContext["color"];
// });


// var rgm = new am4core.RadialGradientModifier();
// rgm.brightnesses.push(-0.8, -0.8, -0.5, 1, 1);
// pieSeries.slices.template.fillModifier = rgm;
// pieSeries.slices.template.strokeModifier = rgm;
 pieSeries.slices.template.strokeOpacity = 2;
 pieSeries.slices.template.strokeWidth = 1;
pieSeries.slices.template.propertyFields.fill = "color";
      },

     
   changedVisaType(item){
     this.selectedCaseTypes = item;
     this.allCaseSubTypes =[];
     this.selectedCaseSubTypes =[];
     if(_.has(this.selectedCaseTypes , "id")){
       this.getvisa_subtypes();
      

     }
      this.getStats();
   },
    getvisa_subtypes() {
      if(this.selectedCaseTypes && _.has(this.selectedCaseTypes ,"id")){

      
      let item = {
        matcher: {
          searchString: '',
          petitionType: parseInt(this.selectedCaseTypes['id']),
          getWorkFlowConfig: false,
        },
        page: 1,
        perpage: 1000,
        category: "petition_sub_types",
        "sorting": {
            "path": "name",
            "order": 1
            }
      };

      this.$store.dispatch("getMasterData", item).then((response) => {
        this.allCaseSubTypes = response.list;
       
      });
      }
    },
        getStats(){
          this.loading =true;
            //dashboard/get-stats
             this.$refs["filter_menu"].dropdownVisible = false;
            this.statusCount =0;
            let payLoad = {
                "categoryList": ['lca-stats-by-status'], //["case-stats-by-status", "pending-actions-count", "lca-stats-by-status", "invoice-stats-by-status", "petitioner-stats-by-status", "pending-cases-stats", "case-aging-stats"],
                "matcher": {
                "statusIds": [],
                "typeIds": [],
                "subTypeIds": [],
                "createdDateRange": []
                }

            }
            if(this.selectedCaseTypes && _.has(this.selectedCaseTypes ,"id")){
                payLoad['matcher']['typeIds'] = [this.selectedCaseTypes['id']];

            }

            if(this.selectedCaseSubTypes.length>0){
                payLoad['matcher']['subTypeIds'] = this.selectedCaseSubTypes.map((item)=>{
                    return item['id'];
                })

            }
             if (
        this.selected_createdDateRange["startDate"] &&
        this.selected_createdDateRange["startDate"] != "" &&
        this.selected_createdDateRange["endDate"] != "" &&
        this.selected_createdDateRange["endDate"]
      ) {
        payLoad["matcher"]["createdDateRange"] = [ 
            this.selected_createdDateRange["startDate"],
            this.selected_createdDateRange["endDate"],
        ];
      }
          this.options['labels'] =[];
           this.series =[];
            this.chartData =[];
            this.$store.dispatch('getStats' ,payLoad)
            .then((result)=>{
             
                if(  _.has( result , 'lcasByStatus' )  &&  _.has( result , 'lcaStatusList' )  ){
                let tempStatus ={};
                _.forEach(result['lcasByStatus'] ,(item)=>{

                   
                    if(_.find(result['lcaStatusList'] ,{"id":item.statusId})){
                        let label = _.find(result['lcaStatusList'] ,{"id":item.statusId});
                        tempStatus[label['name']]  = item.count
                        this.statusCount = this.statusCount+ item.count;
                    }

                });

                 _.forEach(tempStatus ,(val ,key)=>{
                        this.series.push(val);
                        this.options['labels'].push(key);

                        let chartData ={
                        "category": key,
                        "count": val,
                       // "color": "red"
                      };

                    
                      let cls = this.replaceSpaces(key);
                      if(_.has(this.colors,cls)){
                       // alert(cls);
                        chartData =Object.assign(chartData,{ "color":this.colors[cls] })

                      }else{
                        chartData =Object.assign(chartData,{ "color":"#00e300" })
                        
                      }

                      this.chartData.push(chartData);
                     
                                    
                             

                 });
                   this.loading =false;
                  this.initChart();
                 
                // alert( this.statusCount);
            }

              //  alert(JSON.stringify(tempStatus));

            })
            .catch((err)=>{
                this.loading = false;

            })
        }
       
    
        
    },
    computed: {
       
    },
     props:{
    wallsLoaded:{
      type: Boolean,
      default: true
    },
    caseStatusList:{
       type: [Array],
      default: [],
    },
    allCaseTypes:{
       type: [Array],
      default: [],
    },
  }
};
</script>